export interface CookieItem {
  title: string;
  nameLabel: string;
  name: string;
  provider: string;
  expiration: string;
  purpose: string[];
  source: string;
  processor: string;
}

interface CookieDetailProps {
  cookie: CookieItem;
}

function CookieDetail({ cookie }: CookieDetailProps) {

  const [ firstPurpose, ...otherPurposes ] = cookie.purpose;

  return (
    <>
      <div>
        <strong>{cookie.title}</strong>
      </div>
      <div>
        <strong>{cookie.nameLabel}: </strong>
        <span>{cookie.name}</span>
      </div>
      <div>
        <strong>Proveedor: </strong>
        <span>{cookie.provider}</span>
      </div>
      <div>
        <strong>Vigencia: </strong>
        <span>{cookie.expiration}</span>
      </div>
      <div>
        <strong>Finalidad: </strong>
        <span>{firstPurpose}</span>
      </div>
      {otherPurposes.map(purpose => <div key={purpose}>{purpose}</div>)}
      <div>
        <strong>Fuente: </strong>
        <a target="_blank" rel="noopener noreferrer" href={cookie.source}>{cookie.source}</a>
      </div>
      <div>
        <strong>Procesador: </strong>
        <span>{cookie.processor}</span>
      </div>
      <hr />
    </>
  );
}

export default CookieDetail;
